import { useQuery } from "@tanstack/react-query";
import api from "../../../api/api";
import { QUERY_TRANSACTIONS } from "../../../api/queryKeys";
import { QueryTransactionsResponse } from "../../../types";

interface Props {
  page: number;
}

export const getTransactionData = (props: Props) =>
  api
    .get<QueryTransactionsResponse>(QUERY_TRANSACTIONS, {
      params: { page: props.page },
    })
    .then((res) => res.data);

export default function useGetTransactions({ page = 1 }: { page: number }) {
  return useQuery([QUERY_TRANSACTIONS, page], () =>
    getTransactionData({ page })
  );
}
